import { ROLES } from '../config/Constants'

export default () => {
    if (localStorage.getItem('role') === ROLES.SUPER_ADMIN) {
        return false
    } else {
        return true
    }
}
